import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { fetchApi } from '../../../utils/methods';
import { GetCompanyAdminRewardPeriods } from '../../../redux/constants/apiConstants';
import CommonDropdown from '../CommonDropDown/CommonDropdown';

const RewardProgramDropdown = ({ companyId, selectedPeriod, onSelect }) => {
  const [periods, setPeriods] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    fetchPeriods();
  }, [companyId]);

  const fetchPeriods = async () => {
    try {
      const res = await fetchApi(`${GetCompanyAdminRewardPeriods}?company_id=${companyId}`, 'GET');
      if (res.status === 'success') {
        const list = res?.data?.periods || [];
        setPeriods(list);
        if (list.length) {
          onSelect(list[0]);
        }
      } else {
        toast.error(res.message || 'Failed to fetch reward periods');
      }
    } catch (err) {
      window.console.error(err);
    }
  };

  if (!periods.length) return null;

  const title = selectedPeriod
    ? `${dayjs(selectedPeriod.reward_start_date).format('MMM YYYY')} - ${dayjs(selectedPeriod.reward_end_date).format('MMM YYYY')}`
    : 'Select Period';

  return (
    <CommonDropdown
      tileContainerStyle={{ width: '100%', padding: '0px', margin: '0px' }}
      dropdownButtonPadding={'0px 35px 0px 12px'}
      dropdownStyle={{ top: '95px' }}
      dropdownOpen={open}
      placeholder={'Reward Program'}
      title={title}
      id="dropdown-reward-program"
      onClick={() => setOpen((prev) => !prev)}
      data={periods}
      active={selectedPeriod}
      onSelectParameter={['year', 'firstDate', 'month']}
      itemValue={true}
      valueIndex={0}
      labelMargin={'0px'}
      onSelect={(val) => {
        onSelect(val);
        setOpen(false);
      }}
      dropIcon={true}
      isManagerMargin={'0px'}
      top={'8px'}
      showDateRange={true}
      dateRangeKeys={{ start: 'reward_start_date', end: 'reward_end_date' }}
    />
  );
};

RewardProgramDropdown.propTypes = {
  companyId: PropTypes.number.isRequired,
  selectedPeriod: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
};

export default RewardProgramDropdown;
